export const STORE_ID_QUERYSTRING_PARAMETER = 'storeId';
export const OFFER_CODE_QUERYSTRING_PARAMETER = 'offerCode';
export const LANGUAGE_QUERYSTRING_PARAMETER = 'lang';
export const APPOINTMENT_ID_QUERYSTRING_PARAMETER = 'appointmentId';
export const KIOSK_MODE = 'kiosk'; // force kiosk-mode true/false
